import React, { createContext, useContext, useState, useCallback } from 'react';

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    status: null,
    subscriber: null,
    reviewRequired: null,
    minConfidence: null,
    maxConfidence: null,
    search: ''
  });
  
  const [selectedAED, setSelectedAED] = useState(null);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const openDetail = useCallback((aed) => {
    setSelectedAED(aed);
    setIsDetailOpen(true);
  }, []);

  const closeDetail = useCallback(() => {
    setIsDetailOpen(false);
    setSelectedAED(null);
  }, []);

  const triggerRefresh = useCallback(() => {
    setRefreshKey(prev => prev + 1);
  }, []);

  const updateFilter = useCallback((key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters({
      status: null,
      subscriber: null,
      reviewRequired: null,
      minConfidence: null,
      maxConfidence: null,
      search: ''
    });
  }, []);

  return (
    <AppContext.Provider value={{
      filters,
      setFilters,
      updateFilter,
      clearFilters,
      selectedAED,
      setSelectedAED,
      isDetailOpen,
      openDetail,
      closeDetail,
      refreshKey,
      triggerRefresh
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within AppProvider');
  }
  return context;
};
